/* START POLISH-NL */
/* 3-9-2026 — Optivaize, fonteyn.nl: dots bij de showroom-carrousel (media-grid 'showroom-impressie') op mobiel. Geen autorotatie.
   Terugdraaien: include in layout/theme.liquid verwijderen. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 767px)');
  function initDots(gallery) {
    if (gallery.__ftDots) return; gallery.__ftDots = true;
    var slides = gallery.querySelectorAll('.gallery-block');
    if (slides.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'ft-pl-dots'; dots.setAttribute('role', 'tablist'); dots.setAttribute('aria-label', 'Showroomfoto\'s');
    var btns = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' van ' + slides.length);
      b.addEventListener('click', function () { gallery.scrollTo({ left: s.offsetLeft - gallery.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b); btns.push(b);
    });
    gallery.insertAdjacentElement('afterend', dots);
    var raf = null;
    function update() {
      raf = null;
      var x = gallery.scrollLeft, best = 0, bd = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - gallery.offsetLeft) - x); if (d < bd) { bd = d; best = i; } });
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); b.setAttribute('aria-selected', i === best ? 'true' : 'false'); });
    }
    gallery.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function init() {
    if (!MOBILE.matches) return;
    document.querySelectorAll('[id$="__showroom-impressie"] .gallery').forEach(initDots);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* EINDE POLISH-NL */
